import React from 'react'
import { Button } from 'reactstrap'
import { BeatLoader } from 'react-spinners'
import PropTypes from 'prop-types'

/**
 * After the initial upload of the CSV, this button
 * allows the user to check it for errors.
 */
function VerifyButton ({
  handleVerify,
  verifying,
  dataUploaded,
}) {
  return (
    <Button 
      disabled={!dataUploaded || !!verifying} 
      onClick={handleVerify}
    >
      {!verifying && 'Verify'}
      <BeatLoader loading={verifying} />
    </Button>
  )
}

const { bool, func } = PropTypes
VerifyButton.propTypes = {
  dataUploaded: bool,
  handleVerify: func,
  verifying: bool,
}

export default VerifyButton


// WEBPACK FOOTER //
// ./src/components/Assessment/UploadCSVComponents/VerifyButton.js